import { createAction, props } from '@ngrx/store';
import { ItemSelectorActions } from '.';
import { IItemSelectorCategory, IItemSelectorItem } from './reducer';

export function createItemSelectorActions<
  I extends IItemSelectorItem,
  C extends IItemSelectorCategory<I>>(itemSelectorName: string) {
  const prefix = `[InsightsLibrary / ItemSelector / ${itemSelectorName}] `;

  return {
    __prefix: prefix,

    setItemsAndCategories: createAction(
      prefix + 'Set Items And Categories',
      props<{ items: I[], categories: C[] }>()
    ),


    setInitialCategory: createAction(
      prefix + 'Set Initial Category'
    ),

    setSelectedCategory: createAction(
      prefix + 'Set Selected Category',
      props<{ categoryIndex: number }>()
    ),

    setSelectedItem: createAction(
      prefix + 'Set Selected Item',
      props<{ itemIndex: number }>()
    ),


    setStarredOnly: createAction(
      prefix + 'Set Starred Only',
      props<{ starredOnly: boolean }>()
    ),

    setFilter: createAction(
      prefix + 'Set Filter',
      props<{ filter: string }>()
    ),


    updateVisibility: createAction(
      prefix + 'Update Visibility',
      props<{ starredOnlyChanged?: boolean; filterChanged?: boolean }>()
    ),


    updateItem: createAction(
      prefix + 'Update Item',
      props<{ id: number, data: Record<string, any> }>()
    ),
  };
}
